import { render, staticRenderFns } from "./ManageBalanceDistributed.vue?vue&type=template&id=0ec0f91e&"
import script from "./ManageBalanceDistributed.vue?vue&type=script&lang=js&"
export * from "./ManageBalanceDistributed.vue?vue&type=script&lang=js&"
import style0 from "./ManageBalanceDistributed.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports